<div>
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
        [updateStatusType]="updateStatusType" [headerTemplate]="headerTemplate" [(isBusy)]="isBusy"
        [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo"
        [gridContext]="gridContext" [responseArrayCallback]="responseArrayCallback" [gridPagerAfterLoadCustomCallback]="gridPagerCustomCallback"
        [responseCallback]="responseCallback" [contextMenuOptions]="contextMenuOptions" [pagerTemplate]="pagerTemplate"
        [hasContextMenuPermissions]="hasContextMenuPermissions">
    </res-generic-grid>
    <ng-template #headerTemplate>
        <button type="button" data-automation-id="organization-settings-add-new-organization-button"
            class="secondary-button" (click)="addNewOrganization()" *ngIf="hasOrganizationAddEditPermissions">
            <i class="fa fa-plus"></i>{{newOrganization}}
        </button>
        <button type="button" data-automation-id="organization-settings-calculate-storage-button"
            [disabled]="organizations?.length === 0" class="secondary-button btn-spacer" (click)="calculateStorage()"
            *ngIf="hasOrganizationAddEditPermissions" title="Calculate storage for all organizations">
            <i class="fa fa-calculator"></i>Calculate Storage
        </button>
    </ng-template>
    <ng-template #pagerTemplate>
        <button class="download-button" (click)="download()"
            [attr.data-automation-id]="automationId + '-download-button'"
            [attr.title]="'Download the complete organization manifest (.csv)'">
            <i class="fa fa-download"></i>
        </button>
    </ng-template>

</div>
<a download #downloadLink hidden></a>